import PropTypes from 'prop-types';
import React from 'react';

import AddPromoModal from '../containers/AddPromoModal';

const AddPromo = ({ on, off, isOn }) => (
  <div className="u-text-center">
    <button
      type="button"
      className="c-link-button u-type--semibold"
      onClick={on}
    >
      + Add Promo Code
    </button>
    <AddPromoModal
      display-if={isOn}
      close={off}
    />
  </div>
);
AddPromo.propTypes = {
  on: PropTypes.func.isRequired,
  off: PropTypes.func.isRequired,
  isOn: PropTypes.bool.isRequired,
};
AddPromo.defaultProps = {
};

export default AddPromo;
